'use client'
import React from 'react'
import { useTableContext } from '../../../../providers'
import { AnimatePresence, motion } from 'framer-motion'
import { COLLAPSE_ANIMATION_DURATION, COLLAPSE_ANIMATION_EASING } from '../../../../constants/animationConstants'

interface CollapseContentCellProps extends React.HTMLAttributes<HTMLTableRowElement> {
    isCollapsed: boolean
    children: React.ReactNode
}

export const CollapseContentCell = ({ isCollapsed, children }: CollapseContentCellProps): JSX.Element => {
    const { columns, isInline } = useTableContext()

    const lastColumn = columns.at(-1)

    if (!lastColumn || !children) return <></>

    return (
        <AnimatePresence>
            {!isCollapsed && (
                <tr className={`${isInline ? 'border-x border-border-default' : ''}`}>
                    <motion.td
                        key="row"
                        initial={{ visibility: 'collapse' }}
                        animate={{
                            visibility: 'visible',
                            transition: { duration: COLLAPSE_ANIMATION_DURATION, ease: COLLAPSE_ANIMATION_EASING },
                        }}
                        exit={{
                            visibility: 'collapse',
                            transition: { delay: COLLAPSE_ANIMATION_DURATION, ease: COLLAPSE_ANIMATION_EASING },
                            overflow: 'hidden',
                        }}
                        className="table-cell border-border-default border-b bg-shade-0"
                        colSpan={100}
                    >
                        <motion.div
                            key="content"
                            initial="collapsed"
                            animate={isCollapsed ? 'collapsed' : 'open'}
                            exit="collapsed"
                            variants={{
                                open: { opacity: 1, height: 'auto', visibility: 'visible' },
                                collapsed: { opacity: 0, height: 0, visibility: 'hidden' },
                            }}
                            transition={{ duration: COLLAPSE_ANIMATION_DURATION, ease: COLLAPSE_ANIMATION_EASING }}
                            className="w-full"
                        >
                            <div className="pb-4 w-full">{children}</div>
                        </motion.div>
                    </motion.td>
                </tr>
            )}
        </AnimatePresence>
    )
}
